module.exports = __webpack_public_path__ + "img/threeday1-2.34ac86aa.jpg";